import '../scss/manifest.scss';

import navigation from './navigation';
import skipLinkFocusFix from './skip-link-focus-fix';
import search from './search';

navigation.init();
skipLinkFocusFix.init();
search.init();

Array.prototype.slice.call(document.querySelectorAll('.js-flyout')).forEach((element) => {
  element.addEventListener('click', (e) => {
    if (!element.classList.contains('active')) {
      e.preventDefault();
      element.classList.add('active');
    }
    if (e.offsetX > element.offsetWidth || e.offsetX < 0) {
      e.preventDefault();
      element.classList.remove('active');
    }
  });
});
